module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="freeCancellation__sign-container js-open-info-freeCancellation" title="Бесплатная отмена тура">\r\n	<div class="freeCancellation__sign-icon"></div>\r\n</div>\r\n';
}
return __p;
};
